<template>
  <div class="block">
    <img class="page-banner" src="../../static/img/banner.jpg">
    <div class="page-content">
      <h2>
        <img class="smallLogo" src="../../static/img/logo.png" alt="Link2shops">
        {{ $t('brandIntro.title') }}
      </h2>
      <p class="brand-slogan">{{ $t('brandIntro.slogan') }}</p>

      <div class="brand-section">
        <h3>{{ $t('brandIntro.intro.title') }}</h3>
        <p
          v-for="(paragraph, index) in $t('brandIntro.intro.paragraphs')"
          :key="'intro-' + index"
        >{{ paragraph }}</p>
      </div>

      <div class="brand-section">
        <h3>{{ $t('brandIntro.credentials.title') }}</h3>
        <p>{{ $t('brandIntro.credentials.content') }}</p>
      </div>

      <div class="brand-section">
        <h3>{{ $t('brandIntro.background.title') }}</h3>
        <p>{{ $t('brandIntro.background.content') }}</p>
      </div>

      <div class="brand-section brand-ecosystem">
        <h3>{{ $t('brandIntro.ecosystem.title') }}</h3>
        <p>{{ $t('brandIntro.ecosystem.intro') }}</p>
        <div class="partner-categories">
          <div
            v-for="(category, index) in $t('brandIntro.ecosystem.categories')"
            :key="'category-' + index"
            class="partner-category"
          >
            <h4>• {{ category.title }}：{{ category.partners.join('、') }}{{ category.suffix || '' }}</h4>
          </div>
        </div>
      </div>

      <div class="brand-section">
        <h3>{{ $t('brandIntro.aiStrategy.title') }}</h3>
        <p>{{ $t('brandIntro.aiStrategy.content') }}</p>
      </div>

      <company></company>
    </div>
  </div>
</template>
<script type="text/javascript">
  import Company from '../components/Company/Company.vue'
  export default {
    components: {
      company: Company
    }
  }
</script>
<style type="text/css">
  .page-content .smallLogo {
    vertical-align: middle;
    width: 150px;
    height: 30px;
    margin-right: 10px;
  }

  .page-content h2 {
    font-size: 24px;
    line-height: 40px;
    margin-bottom: 20px;
  }

  .brand-slogan {
    font-size: 18px !important;
    font-weight: bold;
    line-height: 32px;
    color: #244893;
    margin-bottom: 24px;
    text-align: center !important;
 
  }

  .brand-section {
    width: 100%;
    float: left;
    text-align: left;
    margin-bottom: 30px;
  }

  .brand-section h3 {
    font-size: 16px;
    line-height: 40px;
    color: #244893;
    margin: 0;
  }

  .brand-section p {
    margin-bottom: 16px;
  }

  .brand-ecosystem {
    margin-bottom: 30px;
  }

  .partner-category {
    margin-bottom: 8px;
  }

  .partner-category h4 {
    font-size: 14px;
    line-height: 32px;
    margin: 0;
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue